import { AddressDto } from '../address-dto';
import { AvatarDto } from '../avatar-dto';

export interface HouseholdDto {
  id: string;
  name: string;
  address: AddressDto | null;
  avatar: AvatarDto | null;
  defaultBillPayerAccountId: string;
  permissions: string[];
}

export interface HouseholdMemberDto {
  accountId: string;
  name: string;
  isDefaultBillPayer: boolean;
  permissions: string[];
}

export interface SaveHouseholdRequest {
  name: string;
  address: AddressDto | null;
}

export interface UpdateHouseholdPermissionsRequest {
  permissionIds: string[];
}

export const householdPermissions = {
  owner: 'ba663985-f722-42ec-bae0-364f3b1993d5',
  fullMember: 'def1a2ad-4b65-4be8-a1cf-2acae9e84af3',
  sessionManager: 'c0b25c97-f988-456c-a593-64d758104e2b'
} as const;

export const householdPermissionOptions = [
  { id: householdPermissions.owner, label: 'Owner' },
  { id: householdPermissions.fullMember, label: 'Full Member' },
  { id: householdPermissions.sessionManager, label: 'Session Manager' }
] as const;
